import { combineReducers, configureStore, createSlice } from '@reduxjs/toolkit';
import { updateFeature } from './handlers';

const appSlice = createSlice({
  name: 'app',
  initialState: {
    features: {},
    loaded: false,
  },
  reducers: {
    setFeatures(state, {payload}) {
      state.features = payload;
    },
    setLoaded(state, {payload}) {
      state.loaded = !!payload;
    },
    toggleFeature(state, action) {
      const {key, value} = action.payload;
      state.features = {...state.features, ...{[key]: value}};

      if (state.loaded) {
        updateFeature(key, value);
      }
    },
  },
});

export const {
  setFeatures,
  setLoaded,
  toggleFeature,
} = appSlice.actions;

const reducer = combineReducers({
  app: appSlice.reducer,
});

const store = configureStore({reducer});

export default store;
